// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"644":"1cd81a71","874":"bcd91c4f"}[chunkId] + ".css";
};